<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import UserPermissions from "../../../components/user-administration/userPermissions.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "User Administration",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, UserPermissions },
    data() {
        return {
            title: "User Administration",
            items: [
                // {
                //     text: "Collection List",
                //     href: "/",
                // },
                // {
                //     text: "Suppliers",
                //     active: true,
                // },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <UserPermissions />
    </Layout>
</template>
